import { supabase } from "../lib/supabase";

const isMissingTable = (error) => error?.code === "PGRST205" || /user_notifications/i.test(error?.message || "");

export const notificationService = {
  async listUnread(recipientId) {
    if (!recipientId) return [];
    const { data, error } = await supabase
      .from("user_notifications")
      .select("*")
      .eq("recipient_id", recipientId)
      .is("read_at", null)
      .order("created_at", { ascending: false })
      .limit(50);
    if (error) {
      if (isMissingTable(error)) return [];
      throw error;
    }
    return data || [];
  },

  async markRead(notificationId, recipientId) {
    if (!notificationId || !recipientId || String(notificationId).startsWith("derived:")) return;
    const { error } = await supabase
      .from("user_notifications")
      .update({ read_at: new Date().toISOString() })
      .eq("id", notificationId)
      .eq("recipient_id", recipientId)
      .is("read_at", null);
    if (error && !isMissingTable(error)) throw error;
  },

  async markAllRead(recipientId) {
    if (!recipientId) return;
    const { error } = await supabase
      .from("user_notifications")
      .update({ read_at: new Date().toISOString() })
      .eq("recipient_id", recipientId)
      .is("read_at", null);
    if (error && !isMissingTable(error)) throw error;
  },

  subscribe(recipientId, onChange) {
    if (!recipientId) return () => {};
    const channel = supabase
      .channel(`user-notifications-${recipientId}`)
      .on("postgres_changes", {
        event: "*",
        schema: "public",
        table: "user_notifications",
        filter: `recipient_id=eq.${recipientId}`,
      }, onChange)
      .subscribe();
    return () => { void supabase.removeChannel(channel); };
  },
};

export default notificationService;
